import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appHSeparator]',
})
export class HSeparatorDirective {
  constructor(private control: NgControl, private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    const isDelete = (event as any).inputType?.startsWith?.('delete') ?? false;
    const formatted = this.format(input.value, isDelete);

    if (input.value !== formatted) {
      this.control.control?.setValue(formatted, { emitEvent: false });
      this.control.valueAccessor?.writeValue(formatted);
      requestAnimationFrame(() => {
        this.el.nativeElement.setSelectionRange(formatted.length, formatted.length);
      });
    }
  }

  @HostListener('blur')
  onBlur() {
    // Final normalize: force the h even for 1–2 digits
    const finalVal = this.format(this.el.nativeElement.value, false);
    this.control.control?.setValue(finalVal || null, { emitEvent: true });
    this.control.valueAccessor?.writeValue(finalVal);
  }

  private format(v: string, isDelete: boolean): string {
    const digits = (v || '').replace(/\D/g, '').slice(0, 4);

    if (digits.length === 0) return '';
    if (digits.length === 1) return isDelete ? digits : `${digits}h`;
    if (digits.length === 2) return isDelete ? digits : `${digits}h`;

    const hh = digits.slice(0, 2);
    let mm = digits.slice(2, 4);

    if (mm.length === 0) return `${hh}h`; // "12h"
    if (mm.length === 1) return `${hh}h${mm}`; // "12h4"

    const mmNum = parseInt(mm, 10);
    if (mmNum > 59) mm = '59';

    return `${hh}h${mm}`; // "12h45" / "12h59"
  }
}
